// extracted by mini-css-extract-plugin
export default {"text":"_5S5Qwi6NSE153IoJOckSNA=="};